'use strict';


Object.defineProperty(exports, "__esModule", {
  value: true
});

function iOS (){
	this.products = [];
	this.options = {forceVerify: true};
	this.parent = null;
	this.cb = null;
	
	
this.init = function(opt, products, parent){
	this.parent = parent;
	if (!window.store) {
		return false;
	} else {
		Object.assign(this.options,opt);
		if(this.options.validator != null && this.options.validator != undefined && this.options.validator != ''){
	store.validator = (p, callback) => { this.validatorStore(p, callback) };			
		}
	this.products = products;
	for(var i = 0; i < this.products.length; i++) {
		var typeProduct; 
		if(this.products[i].type == 0){
			typeProduct = store.CONSUMABLE;
		} else if(this.products[i].type == 1) {
			typeProduct = store.NON_CONSUMABLE;
		} else if(this.products[i].type == 2) {
			typeProduct = store.PAID_SUBSCRIPTION;			
		} 
		store.register({
        id:    this.products[i].id, // id without package name!
        alias: this.products[i].alias,
        type:   typeProduct
		});
		
		store.when(this.products[i].id).approved((p) => { this.manageApproveProduct(p) });
		store.when(this.products[i].id).cancelled((p) => { this.manageCancelledProduct(p) });
		store.when(this.products[i].id).error((p) => { this.manageErrorProduct(p) });
		store.when(this.products[i].id).verified((p) => { this.manageVerifiedProduct(p) });
			
	}
	store.when("product").updated((p) => { this.productUpdate(p) });
	store.refresh();
	return true;	
	}
}
this.validatorStore = function (product, callback) {
	//console.log("validatorstore = ", product);
	if( this.cb != null ) {
		if(product.transaction != null && product.transaction!=undefined) {
	this.parent.callService(this.options.validator, {transactionData: JSON.stringify(product)}, (r) => {
		if(r.code == 900){
			  this.cb(r.data);
			 if(r.data.result === 1) {
		product.finish();		 
		callback(true, product);		
			} else {
		callback(false, "We couldn't verify the purchase");						
			}
		} else {
		callback(false, "We couldn't verify the purchase");						
		}
		});		
	} else{
		callback(false, "We couldn't verify the purchase");								
	}
	} else {
	if(product.transaction != null && product.transaction!=undefined) {
		//console.log("restoring purchase this");
	this.parent.callService(this.options.validator, {transactionData: JSON.stringify(product)}, (r) => {
		if(r.code == 900){
			 if(r.data.result === 1) {
				 this.parent.executeCallbackProducts(r.data.products.split(";"));
				 //console.log("finishing product = ", product);
				  product.finish();
				 callback(true, product);		
			 } else {
				 //console.log("failed finishing product", product);
				callback(false, "We couldn't verify the purchase");										 
			 }
		} else {
				// console.log("failed finishing product", product);
			callback(false, "We couldn't verify the purchase");						
		}
	});		
	} else{
				// console.log("failed finishing product", product);
		callback(false, "We couldn't verify the purchase");								
	}
	}
}
this.resumeActivity = function () {
	store.refresh();
}
this.doCheckout = function(productsSelected, couponData, cb) {
	this.cb = cb;
	store.order(productsSelected[0].id).then(() => {
		//console.log("ordered product");
		this.parent.orderedProduct();
		}).error(() => {
		//console.log("ordered product error");
		this.manageErrorProduct({});	
		});	
}
this.getProducts = function (){
	return this.products;
}
this.manageApproveProduct = function (p){
	//console.log("approved product");
	if(this.options.forceVerify){
		p.verify();
		//p.id = p.id.split('.')[parts.length-1];
		this.parent.approvedProduct(p);
	}else{
		p.finish();
		//p.id = p.id.split('.')[parts.length-1];
		this.parent.finishedProduct(p);
	}
}
this.manageCancelledProduct = function (p){
		//console.log("cancelled product");
		//p.id = p.id.split('.')[parts.length-1];
		this.parent.cancelledProduct(p);
}
this.manageErrorProduct = function (p){
		//console.log("error product");
		//p.id = p.id.split('.')[parts.length-1];
		this.parent.errorProduct(p);
}
this.manageVerifiedProduct = function (p){
		//console.log("verified product");
		p.finish();
		//p.id = p.id.split('.')[parts.length-1];
		this.parent.finishedProduct(p);
}
this.productUpdate = function (p) {
//	var id = p.id.split('.')[parts.length-1];
	var id = p.id;
	var indexProduct = 0;
	for(var i = 0; i < this.products.length; i++){
		if(this.products[i].id == id){
			indexProduct = i;
		}
	}
	//this.products[indexProduct].title = p.title;
	//this.products[indexProduct].description = p.description;
	//this.products[indexProduct].price = p.price;
	this.products[indexProduct].loaded = p.loaded;
	this.products[indexProduct].valid = p.valid;
	this.products[indexProduct].canPurchase = p.canPurchase;	
}

this.updateValidatorURL = function (url) {
	store.validator = url;
	this.options.validator = url;
} 

}

module.exports = iOS;

